export default __webpack_public_path__ + "static/media/printer.6a15e7f8.svg";